// „Продадени продукти / рецепти" — теоретично срещу реално (BE с редизайна,
// `service_sold_analysis.py`). Справките „Продадени" са ТЕОРЕТИЧНИ (текущата
// рецепта × продаденото, по текущата ср. цена); тук е реално изписаното от
// разнасянията и панелът на рецепта. Договорът е в BE docs/inventory.md
// §Продадени: теоретично срещу реално. Количествата и сумите са `number` като
// във всички складови отговори — BE ги сериализира като float, не като Decimal низ.
import { api } from "./client";

export type SoldPeriodParams = {
  startDate: string; // ISO — началото на първия ден
  endDate: string; // ISO — краят на последния ден
};

export interface SoldPostedWarehouse {
  warehouseId: number;
  quantity: number; // изписаното в склада (пряко + вместо друг продукт)
}

// РЕАЛНО изписаното на продукт от разнасянията с дата в периода (датата на
// ОТЧЕТА, не на затваряне на сметките). Трите количества не се припокриват:
// физически от склада е излязло `postedQuantity + donorQuantity`.
export interface SoldPostedProduct {
  productId: number;
  name: string;
  unit: string | null;
  postedQuantity: number; // редовете на разнасянето (вече без покритото от замяна)
  postedValueNoVat: number; // FIFO себестойност към разнасянето
  postedValueWithVat: number;
  donorQuantity: number; // изписано ВМЕСТО друг продукт
  donorValueNoVat: number;
  donorValueWithVat: number;
  coveredQuantity: number; // нуждата му, покрита от друг продукт (не е изписана)
  postingsCount: number;
  warehouses: SoldPostedWarehouse[]; // най-голямото първо
}

export async function getSoldProductsPosted(params: SoldPeriodParams): Promise<SoldPostedProduct[]> {
  const res = await api.get<SoldPostedProduct[]>("/inventory/sold-products/posted", { params });
  return res.data;
}

// Един разнесен отчет, в който рецептата е продадена (сметките, затворени в периода)
export interface SoldRecipeReport {
  reportId: number;
  reportNumber: number | null;
  reportDate: string | null;
  postingId: number | null; // разнасянето — документът, който се отваря
  postingDate: string | null;
  quantity: number;
  totalSum: number; // продажна стойност (с ДДС)
}

// Съставка по ТЕКУЩАТА рецепта × продаденото — теоретичният разход
export interface SoldRecipeIngredient {
  productId: number;
  name: string;
  unit: string | null;
  perPortion: number;
  quantity: number;
  unitCost: number; // текущата себестойност (нето)
  valueNoVat: number;
  valueWithVat: number;
}

export interface SoldRecipeBreakdown {
  sellableId: number;
  name: string;
  quantity: number; // = редът в справката
  totalSum: number;
  reports: SoldRecipeReport[];
  ingredients: SoldRecipeIngredient[];
}

export async function getSoldRecipeBreakdown(
  params: SoldPeriodParams & { sellableId: number },
): Promise<SoldRecipeBreakdown> {
  const res = await api.get<SoldRecipeBreakdown>("/inventory/sold-recipes/breakdown", { params });
  return res.data;
}
